import { gql } from '@apollo/client'

export const GENERATE_CHAT = gql`
  mutation GenerateChat($input: GenerateInput!) {
    generate(input: $input) {
      content contentType
    }
  }
`
